import React, { Component } from 'react';
import { Card, CardText, CardTitle } from 'material-ui/Card';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Snackbar from 'material-ui/Snackbar';
import QueryBuilder from 'material-ui/svg-icons/action/query-builder';
import ZoomIn from 'material-ui/svg-icons/action/zoom-in';
import Close from 'material-ui/svg-icons/navigation/close';
import Place from 'material-ui/svg-icons/maps/place';
import LocalPhone from 'material-ui/svg-icons/maps/local-phone';
import Visibility from 'material-ui/svg-icons/action/visibility';
import Chip from 'material-ui/Chip';
import Badge from 'material-ui/Badge';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';

import Loading from '../components/Loading';
import getNumberStyle from '../utils';
import PaginationFooter from '../components/PaginationFooter';
import ConferenceDetail from './ConferenceDetail';
import CompanyDetail from './CompanyDetail';
import ConferenceGeolocation from './ConferenceGeolocation';
import API from "../api/ApiTool";

const styles = {
  flex: {
    display: 'flex'
  },
  card: {
    backgroundColor: '#0f172a',
    border: '1px solid #1e293b',
    borderRadius: '8px',
    margin: '8px',
    height: '200px',
    width: '240px',
    position: 'relative',
    transition: 'border-color 0.15s ease',
  },
  icon: {
    float: 'right',
    width: 36,
    height: 36,
    padding: 12,
    color: '#06b6d4',
  },
  title: {
    fontWeight: '700',
    color: '#e5e7eb',
    fontSize: '22px',
    marginTop: '4px',
    fontFamily: '"Inter", system-ui, sans-serif',
  },
  plivoNumber: {
    fontSize: '14px',
    color: '#22c55e',
    marginTop: '4px',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontWeight: 500,
  },
  twilioNumber: {
    fontSize: '14px',
    color: '#f43f5e',
    marginTop: '4px',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontWeight: 500,
  },
  telnyxNumber: {
    fontSize: '14px',
    color: '#3b82f6',
    marginTop: '4px',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontWeight: 500,
  },
  bandwidthNumber: {
    fontSize: '14px',
    color: '#f59e0b',
    marginTop: '4px',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontWeight: 500,
  },
  actions: {
    cursor: 'pointer',
    marginTop: '12px',
    color: '#3b82f6'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '20px 0 8px 0',
  },
  sectionTitle: {
    color: '#94a3b8',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  badge: {
    backgroundColor: '#3b82f6',
    color: '#fff',
    borderRadius: '10px',
    padding: '2px 10px',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: '"Inter", system-ui, sans-serif',
  },
  cardLabel: {
    position: 'absolute',
    padding: 0,
    bottom: 8,
    paddingLeft: 16,
    color: '#64748b',
    fontSize: '11px',
    fontFamily: '"Inter", system-ui, sans-serif',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    fontWeight: 600,
  },
  loadingMore: {
    color: '#94a3b8',
    fontFamily: '"Inter", system-ui, sans-serif',
    marginLeft: '15px',
    fontSize: '13px',
  },
};

const ConferencesTable = (props) => {
  const { conferences } = props.data;
  if (props.loading) {
    return <Loading />
  }
  return (
    <div>
      <Table selectable={false} style={{backgroundColor: '#0f172a'}}>
        <TableHeader>
          <TableRow>
            <TableHeaderColumn>Company</TableHeaderColumn>
            <TableHeaderColumn style={{width: '180px'}}>Bridge Number</TableHeaderColumn>
            <TableHeaderColumn>FS server</TableHeaderColumn>
            <TableHeaderColumn>Started At</TableHeaderColumn>
            <TableHeaderColumn>Callers</TableHeaderColumn>
            <TableHeaderColumn>Minutes</TableHeaderColumn>
            <TableHeaderColumn>Actions</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody>
          {conferences.map((conference, i) =>
            <TableRow key={i}>
              <TableRowColumn>{
                  conference.bridge.company
                  ? <a style={styles.actions}
                      onClick={() => props.companyDetail(conference.bridge.company.id)}>
                      {conference.bridge.company.name}
                    </a>
                  : '-'
              }</TableRowColumn>
              <TableRowColumn style={{width: '180px'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Chip style={getNumberStyle(conference.bridge.service_provider)}>
                    {conference.bridge.service_provider} - {conference.bridge.billing_provider}
                  </Chip>
                  <div style={{marginTop: '0px', fontSize: '12px', color: '#94a3b8'}}>{conference.bridge.bridge_number}</div>
                </div>
              </TableRowColumn>
              <TableRowColumn>{conference.fs_server}</TableRowColumn>
              <TableRowColumn>
                <Moment format="YYYY/MM/DD HH:mm">
                  {conference.created}
                </Moment>
              </TableRowColumn>
              <TableRowColumn style={{color: '#06b6d4', fontWeight: 600}}>
                {props.activeConferencesMode ? conference.calls_in_progress : conference.conference_calls_count}
              </TableRowColumn>
              <TableRowColumn>{conference.minutes_used}</TableRowColumn>
              <TableRowColumn>
                <ZoomIn
                  style={styles.actions}
                  onClick={() => props.conferenceDetail(conference.id)}>
                </ZoomIn>
                <Place
                  style={styles.actions}
                  onClick={() => props.geolocationDetail(conference.id)}>
                </Place>
                {props.activeConferencesMode
                  ?
                    <Close
                      style={{...styles.actions, color: '#f43f5e'}}
                      onClick={() => props.alertHandleOpen(conference.id, conference.calls_in_progress)}>
                    </Close>
                  :
                    undefined
                }
                <Visibility
                  style={styles.actions}
                  onClick={()=> window.open(
                    `https://app.brandedbridgeline.com/app/#/users/view-as/${conference.bridge.company.id}/`, '_blank'
                  )} />
              </TableRowColumn>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <div>
        {!props.activeConferencesMode && props.loadingMoreTodayConferences
          ?
            <p style={styles.loadingMore}>Loading more...</p>
          :
            undefined
        }
      </div>
    </div>
  );
}

const MetrictsCards = (data) => {
  return (
    <div style={{display: 'flex', flexWrap: 'wrap', padding: '8px'}}>
        <Card style={styles.card}>
          <QueryBuilder style={styles.icon} />
          <CardTitle>
            <div style={styles.title}>{data.today_minutes}</div>
            <div style={styles.plivoNumber}>Plivo: {data.today_minutes_plivo}</div>
            <div style={styles.twilioNumber}>Twilio: {data.today_minutes_twilio}</div>
            <div style={styles.telnyxNumber}>Telnyx: {data.today_minutes_telnyx}</div>
            <div style={styles.bandwidthNumber}>Bandwidth: {data.today_minutes_bw}</div>
          </CardTitle>
          <CardText style={styles.cardLabel}>Today&apos;s Minutes</CardText>
        </Card>
        <Card style={styles.card}>
          <QueryBuilder style={styles.icon} />
          <CardTitle>
            <div style={styles.title}>
              {`${data.month_minutes}`}
              <span style={{fontSize: '12px', color: '#64748b', fontWeight: 400, marginLeft: '6px'}}>
                ({data.last_month_minutes} last mo)
              </span>
            </div>
            <div style={styles.plivoNumber}>Plivo: {data.month_minutes_plivo}</div>
            <div style={styles.twilioNumber}>Twilio: {data.month_minutes_twilio}</div>
            <div style={styles.telnyxNumber}>Telnyx: {data.month_minutes_telnyx}</div>
            <div style={styles.bandwidthNumber}>Bandwidth: {data.month_minutes_bw}</div>
          </CardTitle>
          <CardText style={styles.cardLabel}>Month&apos;s Minutes</CardText>
        </Card>
        <Card style={styles.card}>
          <LocalPhone style={styles.icon} />
          <CardTitle>
            <div style={styles.plivoNumber}>Plivo: {data.plivo_numbers}</div>
            <div style={styles.twilioNumber}>Twilio: {data.twilio_numbers}</div>
            <div style={styles.telnyxNumber}>Telnyx: {data.telnyx_numbers}</div>
            <div style={styles.bandwidthNumber}>Bandwidth: {data.bandwidth_numbers}</div>
          </CardTitle>
          <CardText style={styles.cardLabel}>DIDs Per Provider</CardText>
        </Card>
        <Card style={styles.card}>
          <LocalPhone style={styles.icon} />
          <CardTitle>
            <div style={styles.plivoNumber}>Plivo: {data.plivo_total_current_callers}</div>
            <div style={styles.twilioNumber}>Twilio: {data.twilio_total_current_callers}</div>
            <div style={styles.telnyxNumber}>Telnyx: {data.telnyx_total_current_callers}</div>
            <div style={styles.bandwidthNumber}>Bandwidth: {data.bandwidth_total_current_callers}</div>
          </CardTitle>
          <CardText style={styles.cardLabel}>In Progress Per Provider</CardText>
        </Card>
    </div>
  );
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      activeConferences: {total: '-'},
      todayConferences: {total: '-'},
      loadingMetricts: true,
      loadingActiveConferences: true,
      loadingTodayConferences: true,
      loadingMoreTodayConferences: false,
      closeConferenceAlertOpen: false,
      notificationOpen: false,
      notificationText: '',
      conferenceID: undefined,
      companyID: undefined,
      conferenceDetailOpen: false,
      companyDetaillOpen: false,
      geolocationOpen: false,
      limit: 50
    };

    window.onscroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop
        === document.documentElement.offsetHeight
      ) {
        const todayConferences = this.state.todayConferences;
        const loadingMoreTodayConferences = this.state.loadingMoreTodayConferences;
        if (todayConferences.conferences && todayConferences.conferences.length < todayConferences.total && !loadingMoreTodayConferences) {
          this.fetchMoreData();
        }
      }
    };
  }

  conferenceDetailClose = () => {
    this.setState({ conferenceDetailOpen: false });
  };

  companyDetailClose = () => {
    this.setState({ companyDetaillOpen: false });
  };

  geolocationClose = () => {
    this.setState({ geolocationOpen: false });
  };

  componentDidMount() {
    this.setState({ loadingMetricts: true });
    this.setState({ loadingActiveConferences: true });
    this.setState({ loadingTodayConferences: true });

    API.GET(`/bridges/metrics/`)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        else {
          this.props.history.push(`/login`);
        }
      })
      .then(data => {
        this.setState({ data });
        this.setState({ loadingMetricts: false });
      });

    API.POST(`/bridges/active-conferences/`, {})
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        else {
          this.props.history.push(`/login`);
        }
      })      
      .then(data => {
        this.setState({ activeConferences: data });
        this.setState({ loadingActiveConferences: false });
      });

    API.POST(`/bridges/today-conferences/`, {'offset': 0, 'limit': this.state.limit })      
      .then(response => response.json())
      .then(data => {
        this.setState({ todayConferences: data });
        this.setState({ loadingTodayConferences: false });
      });
  }

  fetchMoreData = () => {    
    const limit = this.state.limit;
    const offset = this.state.todayConferences.offset;
    let todayConferences = this.state.todayConferences;

    this.setState({ loadingMoreTodayConferences: true });

    API.POST(`/bridges/today-conferences/`, { 'offset': offset, 'limit': limit })    
      .then(response => response.json())
      .then(data => {
        todayConferences.conferences = todayConferences.conferences.concat(data.conferences);
        todayConferences.offset = data.offset;
        this.setState({ todayConferences: todayConferences });
        this.setState({ loadingMoreTodayConferences: false });
      });
  };

  conferenceDetail(id) {
    this.setState({ conferenceDetailOpen: true });
    this.setState({ conferenceID: id });
  }

  geolocationDetail(id) {
    this.setState({ geolocationOpen: true });
    this.setState({ conferenceID: id });
  }

  companyDetail(id) {
    this.setState({ companyDetaillOpen: true });
    this.setState({ companyID: id });
  }

  closeConference(conferenceID) {
    const id = conferenceID || this.state.conferenceID;

    API.POST(`/bridges/close-conference/`, { 'id': id })
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          this.setState({ closeConferenceAlertOpen: false });
          this.setState({ notificationOpen: true });
          this.setState({ notificationText: 'Conference closed successfully' });
          this.setState({ loadingActiveConferences: true });
          API.POST(`/bridges/active-conferences/`, {})            
            .then(response => response.json())
            .then(data => {
              this.setState({ activeConferences: data });
              this.setState({ loadingActiveConferences: false });
              this.setState({ notificationOpen: false });
            });
        }
      })
      .catch(() => {
        this.setState({ loadingActiveConferences: false });
        this.setState({ notificationOpen: true });
        this.setState({
          notificationText: 'The server encountered an error. Please try again later'
        });
      });
  }

  alertHandleOpen = (conferenceID, inProgressCallCount) => {
    this.setState({ conferenceID: conferenceID });
    this.setState({ notificationOpen: false });
    this.setState({ notificationText: '' });

    if (inProgressCallCount === undefined || inProgressCallCount > 1) {
      this.setState({ closeConferenceAlertOpen: true });
      this.setState({ notificationOpen: false });
      this.setState({ notificationText: '' });
      this.setState({ conferenceID: conferenceID })
    }
    else {
      this.closeConference(conferenceID);
    }
  };

  alertHandleClose = () => {
    this.setState({ closeConferenceAlertOpen: false });
  };

  render() {
    const { data, activeConferences, todayConferences, closeConferenceAlertOpen,
      notificationOpen, notificationText, loadingMetricts,
      loadingActiveConferences, loadingTodayConferences,
      conferenceDetailOpen, loadingMoreTodayConferences,
      companyDetaillOpen, geolocationOpen } = this.state;

    if (loadingMetricts) {
      return (
        <Loading />
      );
    }
    return (
      <div>
        <Dialog
          fullScreen
          open={conferenceDetailOpen}
        >
          <AppBar color="default" style={{backgroundColor: '#030712'}}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.conferenceDetailClose} aria-label="Close">
                <Close color="#e5e7eb"/>
              </IconButton>
              <Typography variant="h6" color="inherit" >
                Conference Detail View
              </Typography>
            </Toolbar>
          </AppBar>
          <ConferenceDetail id={this.state.conferenceID} left={60}/>
        </Dialog>

        <Dialog
          fullScreen
          open={companyDetaillOpen}
        >
          <AppBar color="default" style={{backgroundColor: '#030712'}}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.companyDetailClose} aria-label="Close">
                <Close color="#e5e7eb"/>
              </IconButton>
              <Typography variant="h6" color="inherit" >
                Company Detail
              </Typography>
            </Toolbar>
          </AppBar>
          <CompanyDetail id={this.state.companyID} left={60}/>
        </Dialog>

        <Dialog
          fullScreen
          open={geolocationOpen}
        >
          <AppBar color="default" style={{backgroundColor: '#030712'}}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.geolocationClose} aria-label="Close">
                <Close color="#e5e7eb"/>
              </IconButton>
              <Typography variant="h6" color="inherit" >
                Geolocation Detail
              </Typography>
            </Toolbar>
          </AppBar>
          <ConferenceGeolocation id={this.state.conferenceID} left={60}/>
        </Dialog>

        <Dialog
          open={closeConferenceAlertOpen}
          onClose={() => this.alertHandleClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Close conference DB"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are going to force the DB to close a conference. Proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.alertHandleClose()} color="primary">
              Cancel
            </Button>
            <Button onClick={() => this.closeConference()} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={notificationOpen}
          message={notificationText}
          autoHideDuration={4000}
        />

        <MetrictsCards {...data} />

        <div>
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTitle}>Active Conferences</span>
            <span style={styles.badge}>{activeConferences.total}</span>
          </div>
          <ConferencesTable
            data={activeConferences}
            companyDetail={this.companyDetail.bind(this)}
            conferenceDetail={this.conferenceDetail.bind(this)}
            geolocationDetail={this.geolocationDetail.bind(this)}
            push={this.props.history.push}
            activeConferencesMode={true}
            alertHandleOpen={this.alertHandleOpen.bind(this)}
            loading={loadingActiveConferences}
          />
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTitle}>Today&apos;s Conferences</span>
            <span style={styles.badge}>{todayConferences.total}</span>
          </div>
          <ConferencesTable
            data={todayConferences}
            companyDetail={this.companyDetail.bind(this)}
            conferenceDetail={this.conferenceDetail.bind(this)}
            geolocationDetail={this.geolocationDetail.bind(this)}
            push={this.props.history.push}
            activeConferencesMode={false}
            alertHandleOpen={this.alertHandleOpen.bind(this)}
            loading={loadingTodayConferences}
            loadingMoreTodayConferences={loadingMoreTodayConferences}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js